import { IconName } from '@shared/ui/icon/ui-icon.component';

export interface NavItem {
  label: string;
  icon: IconName;
  route: string;
  badge?: string;
  /** Clave `aux_recursos.clave` para `ver`. */
  permission?: string;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const ADMIN_NAV_SECTIONS: NavSection[] = [
  {
    title: 'Operación',
    items: [
      { label: 'Dashboard', icon: 'dashboard', route: '/app/dashboard', permission: 'dashboard' },
      { label: 'Solicitudes', icon: 'users', route: '/app/conductores/solicitudes', permission: 'solicitudes' },
      { label: 'Conductores', icon: 'users', route: '/app/conductores', permission: 'conductores' },
      { label: 'Clientes', icon: 'users', route: '/app/clientes', permission: 'clientes' },
      { label: 'Vehículos', icon: 'car', route: '/app/vehiculos', permission: 'vehiculos' },
      { label: 'GPS y Pánico', icon: 'map', route: '/app/gps-panico', permission: 'gps_panico' },
      { label: 'Viajes', icon: 'route', route: '/app/viajes', permission: 'viajes' }
    ]
  },
  {
    title: 'Finanzas',
    items: [
      { label: 'Cobros', icon: 'wallet', route: '/app/cobros', permission: 'cobros' },
      { label: 'Cortes', icon: 'receipt', route: '/app/cortes', permission: 'cortes' },
      { label: 'Facturación', icon: 'receipt', route: '/app/facturacion', permission: 'facturacion' },
      { label: 'Tarifas', icon: 'settings', route: '/app/tarifas', permission: 'tarifas' }
    ]
  },
  {
    title: 'Sistema',
    items: [
      { label: 'Reportes', icon: 'chart', route: '/app/reportes', permission: 'reportes' },
      { label: 'Catálogos', icon: 'book', route: '/app/catalogos', permission: 'catalogos' },
      { label: 'Auditoría', icon: 'shield', route: '/app/auditoria', permission: 'auditoria' },
      { label: 'Roles', icon: 'shield', route: '/app/roles', permission: 'roles' },
      { label: 'Usuarios', icon: 'users', route: '/app/usuarios', permission: 'usuarios' }
    ]
  },
  {
    title: 'Desarrollo',
    items: [
      { label: 'Design System', icon: 'settings', route: '/app/design-system', permission: 'dev.design_system' }
    ]
  }
];
